export default __webpack_public_path__ + "static/media/46MD63.cc2b5d26.png";